<template>
	<div class="container__planejamento__pilha">
		<div class="container__planejamento__pilha__estrato">
			<i class="fas fa-tree" />
			<p>{{ estratoFlorestal }}</p>
		</div>
		<div class="container__planejamento__pilha__tabs">
			<Tab
				text="Medidas"
				:active="tabMedidasEstaAtivo"
				style="width: 100%"
				@click="exibirFormularioDeMedidas"
			/>
			<Tab
				text="Fator"
				:active="tabFatorEstaAtivo"
				style="width: 100%"
				@click="exibirFormularioDeFator"
			/>
		</div>
		<div class="container__planejamento__pilha__formulario">
			<div
				v-show="tabMedidasEstaAtivo"
				class="container__planejamento__pilha__formulario__medidas"
			>
				<svg
					class="container__planejamento__pilha__formulario__imagem__exemplo"
					width="325"
					height="206"
					viewBox="0 0 325 206"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						x="31.7071"
						y="154.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 31.7071 154.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="49.3848"
						cy="154.066"
						r="12.5"
						transform="rotate(-45 49.3848 154.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="58.2684"
						y="153.627"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 58.2684 153.627)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="75.9461"
						cy="153.627"
						r="12.5"
						transform="rotate(-45 75.9461 153.627)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="84.7071"
						y="154.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 84.7071 154.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="102.385"
						cy="154.066"
						r="12.5"
						transform="rotate(-45 102.385 154.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="111.268"
						y="153.627"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 111.268 153.627)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="128.946"
						cy="153.627"
						r="12.5"
						transform="rotate(-45 128.946 153.627)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="44.7071"
						y="130.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 44.7071 130.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="62.3848"
						cy="130.066"
						r="12.5"
						transform="rotate(-45 62.3848 130.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="71.1458"
						y="130.505"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 71.1458 130.505)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="88.8235"
						cy="130.505"
						r="12.5"
						transform="rotate(-45 88.8235 130.505)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="97.7071"
						y="130.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 97.7071 130.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="115.385"
						cy="130.066"
						r="12.5"
						transform="rotate(-45 115.385 130.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="57.7071"
						y="106.505"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 57.7071 106.505)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="75.3848"
						cy="106.505"
						r="12.5"
						transform="rotate(-45 75.3848 106.505)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="84.2684"
						y="106.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 84.2684 106.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="101.946"
						cy="106.066"
						r="12.5"
						transform="rotate(-45 101.946 106.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="138.268"
						y="153.627"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 138.268 153.627)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="155.946"
						cy="153.627"
						r="12.5"
						transform="rotate(-45 155.946 153.627)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="124.707"
						y="130.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 124.707 130.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="142.385"
						cy="130.066"
						r="12.5"
						transform="rotate(-45 142.385 130.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="111.268"
						y="106.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 111.268 106.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="128.946"
						cy="106.066"
						r="12.5"
						transform="rotate(-45 128.946 106.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="165.268"
						y="153.627"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 165.268 153.627)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="182.946"
						cy="153.627"
						r="12.5"
						transform="rotate(-45 182.946 153.627)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="151.707"
						y="130.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 151.707 130.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="169.385"
						cy="130.066"
						r="12.5"
						transform="rotate(-45 169.385 130.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="138.268"
						y="106.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 138.268 106.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="155.946"
						cy="106.066"
						r="12.5"
						transform="rotate(-45 155.946 106.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="192.268"
						y="153.627"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 192.268 153.627)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="209.946"
						cy="153.627"
						r="12.5"
						transform="rotate(-45 209.946 153.627)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="178.707"
						y="130.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 178.707 130.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="196.385"
						cy="130.066"
						r="12.5"
						transform="rotate(-45 196.385 130.066)"
						fill="white"
						stroke="#01395E"
					/>
					<rect
						x="165.268"
						y="106.066"
						width="149"
						height="25"
						rx="12.5"
						transform="rotate(-45 165.268 106.066)"
						fill="#F1F5F8"
						stroke="#01395E"
					/>
					<circle
						cx="182.946"
						cy="106.066"
						r="12.5"
						transform="rotate(-45 182.946 106.066)"
						fill="white"
						stroke="#01395E"
					/>

					<path
						id="pilha_altura_comprimento_barra"
						class="container__planejamento__imagem__transition"
						d="M24 95L24 165"
						stroke="#01395E"
						stroke-width="2"
						stroke-linecap="round"
					/>
					<path
						id="pilha_altura_comprimento_texto"
						class="container__planejamento__imagem__transition"
						d="M4 110.506L6.77539 109.528V105.707L4 104.729V103L14.0352 106.719V108.537L4 112.249V110.506ZM8.18359 109.104L10.918 108.154C11.0365 108.118 11.2028 108.065 11.417 107.997C11.6357 107.929 11.8568 107.86 12.0801 107.792C12.3079 107.724 12.4993 107.667 12.6543 107.621C12.4674 107.576 12.2578 107.519 12.0254 107.45C11.7975 107.386 11.5833 107.323 11.3828 107.259C11.1823 107.2 11.0273 107.154 10.918 107.122L8.18359 106.165V109.104ZM4 113.568H13.9941V115.209H5.39453V119.454H4V113.568ZM4 124.649L4 123.002H12.5996L12.5996 120.076H13.9941L13.9941 127.568H12.5996V124.649H4ZM13.9941 136.947H7.52734C6.83008 136.947 6.20573 136.799 5.6543 136.503C5.10286 136.211 4.66536 135.769 4.3418 135.177C4.02279 134.584 3.86328 133.839 3.86328 132.941C3.86328 131.661 4.19824 130.686 4.86816 130.016C5.54264 129.35 6.43815 129.018 7.55469 129.018H13.9941V130.658H7.69824C6.86426 130.658 6.24902 130.854 5.85254 131.246C5.45605 131.638 5.25781 132.224 5.25781 133.003C5.25781 133.541 5.35124 133.978 5.53809 134.315C5.72949 134.657 6.00749 134.908 6.37207 135.067C6.74121 135.231 7.18555 135.313 7.70508 135.313H13.9941V136.947ZM13.9941 142.313C13.9941 143.175 13.8893 143.886 13.6797 144.446C13.4701 145.011 13.151 145.431 12.7227 145.704C12.2943 145.982 11.7497 146.121 11.0889 146.121C10.5967 146.121 10.1774 146.03 9.83105 145.848C9.4847 145.665 9.19759 145.426 8.96973 145.13C8.74186 144.834 8.55957 144.517 8.42285 144.18L4 147.017V145.164L8.00586 142.751V141.145H4V139.504H13.9941L13.9941 142.313ZM12.627 142.204V141.145H9.35937V142.279C9.35937 143.04 9.50065 143.592 9.7832 143.934C10.0658 144.28 10.4827 144.453 11.0342 144.453C11.613 144.453 12.0231 144.269 12.2646 143.899C12.5062 143.535 12.627 142.97 12.627 142.204ZM4 154.639L6.77539 153.661L6.77539 149.84L4 148.862V147.133L14.0352 150.852V152.67L4 156.382V154.639ZM8.18359 153.237L10.918 152.287C11.0365 152.251 11.2028 152.198 11.417 152.13C11.6357 152.062 11.8568 151.993 12.0801 151.925C12.3079 151.856 12.4993 151.799 12.6543 151.754C12.4674 151.708 12.2578 151.651 12.0254 151.583C11.7975 151.519 11.5833 151.455 11.3828 151.392C11.1823 151.332 11.0273 151.287 10.918 151.255L8.18359 150.298L8.18359 153.237Z"
						fill="#01395E"
					/>

					<path
						id="pilha_altura_comprimento_barra"
						class="container__planejamento__imagem__transition"
						d="M37 182H221"
						stroke="#01395E"
						stroke-width="2"
						stroke-linecap="round"
					/>
					<path
						id="pilha_altura_comprimento_texto"
						class="container__planejamento__imagem__transition"
						d="M81.5713 193.257C81.0928 193.257 80.6644 193.343 80.2861 193.517C79.9124 193.69 79.5957 193.94 79.3359 194.269C79.0762 194.592 78.8779 194.986 78.7412 195.451C78.6045 195.911 78.5361 196.431 78.5361 197.01C78.5361 197.785 78.6455 198.452 78.8643 199.013C79.083 199.569 79.4157 199.997 79.8623 200.298C80.3089 200.594 80.874 200.742 81.5576 200.742C81.9814 200.742 82.3939 200.701 82.7949 200.619C83.196 200.537 83.6107 200.425 84.0391 200.284V201.679C83.6335 201.838 83.2233 201.954 82.8086 202.027C82.3939 202.1 81.9154 202.137 81.373 202.137C80.3522 202.137 79.5046 201.925 78.8301 201.501C78.1602 201.077 77.6589 200.48 77.3262 199.71C76.998 198.94 76.834 198.037 76.834 197.003C76.834 196.246 76.9388 195.554 77.1484 194.925C77.3581 194.296 77.6634 193.754 78.0645 193.298C78.4655 192.838 78.96 192.484 79.5479 192.238C80.1403 191.988 80.8171 191.862 81.5781 191.862C82.0794 191.862 82.5716 191.919 83.0547 192.033C83.5423 192.143 83.9935 192.3 84.4082 192.505L83.834 193.858C83.4876 193.694 83.1253 193.553 82.7471 193.435C82.3688 193.316 81.9769 193.257 81.5713 193.257ZM95.0586 196.989C95.0586 197.759 94.9606 198.461 94.7646 199.095C94.5732 199.724 94.2839 200.266 93.8965 200.722C93.5091 201.173 93.0238 201.521 92.4404 201.768C91.8571 202.014 91.1735 202.137 90.3896 202.137C89.5921 202.137 88.8994 202.014 88.3115 201.768C87.7282 201.521 87.2428 201.171 86.8555 200.715C86.4727 200.259 86.1855 199.715 85.9941 199.081C85.8027 198.448 85.707 197.746 85.707 196.976C85.707 195.946 85.8757 195.048 86.2129 194.282C86.5547 193.512 87.0719 192.915 87.7646 192.491C88.4619 192.063 89.3415 191.849 90.4033 191.849C91.4424 191.849 92.306 192.061 92.9941 192.484C93.6823 192.908 94.1973 193.505 94.5391 194.275C94.8854 195.041 95.0586 195.946 95.0586 196.989ZM87.4297 196.989C87.4297 197.759 87.5345 198.427 87.7441 198.992C87.9538 199.553 88.2751 199.986 88.708 200.291C89.1455 200.592 89.7061 200.742 90.3896 200.742C91.0778 200.742 91.6383 200.592 92.0713 200.291C92.5042 199.986 92.8232 199.553 93.0283 198.992C93.2334 198.427 93.3359 197.759 93.3359 196.989C93.3359 195.818 93.1012 194.902 92.6318 194.241C92.167 193.576 91.4242 193.243 90.4033 193.243C89.7197 193.243 89.1569 193.394 88.7148 193.694C88.2773 193.995 87.9538 194.426 87.7441 194.986C87.5345 195.542 87.4297 196.21 87.4297 196.989ZM101.519 202L98.6406 193.653H98.5791C98.5928 193.84 98.6087 194.095 98.627 194.419C98.6452 194.743 98.6611 195.089 98.6748 195.458C98.6885 195.827 98.6953 196.18 98.6953 196.518V202H97.2051V192.006H99.5088L102.277 199.983H102.318L105.183 192.006H107.479V202H105.914V196.436C105.914 196.13 105.919 195.8 105.928 195.444C105.941 195.089 105.955 194.752 105.969 194.433C105.987 194.114 106.001 193.858 106.01 193.667H105.955L102.968 202H101.519ZM113.017 192.006C114.306 192.006 115.247 192.27 115.84 192.799C116.432 193.327 116.729 194.068 116.729 195.021C116.729 195.453 116.66 195.866 116.523 196.258C116.391 196.645 116.173 196.989 115.867 197.29C115.562 197.586 115.159 197.821 114.657 197.994C114.16 198.167 113.548 198.254 112.818 198.254H111.752V202H110.111V192.006H113.017ZM112.907 193.366H111.752V196.887H112.647C113.162 196.887 113.6 196.827 113.96 196.709C114.32 196.586 114.593 196.392 114.78 196.128C114.967 195.864 115.061 195.515 115.061 195.082C115.061 194.503 114.885 194.073 114.534 193.79C114.188 193.507 113.646 193.366 112.907 193.366ZM121.534 192.006C122.396 192.006 123.106 192.111 123.667 192.32C124.232 192.53 124.651 192.849 124.925 193.277C125.203 193.706 125.342 194.25 125.342 194.911C125.342 195.403 125.251 195.823 125.068 196.169C124.886 196.515 124.647 196.802 124.351 197.03C124.054 197.258 123.738 197.44 123.4 197.577L126.237 202H124.385L121.972 197.994H120.365V202H118.725V192.006H121.534ZM121.425 193.373H120.365V196.641H121.5C122.261 196.641 122.812 196.499 123.154 196.217C123.501 195.934 123.674 195.517 123.674 194.966C123.674 194.387 123.489 193.977 123.12 193.735C122.756 193.494 122.19 193.373 121.425 193.373ZM127.666 202V192.006H129.307V202H127.666ZM136.259 202L133.381 193.653H133.319C133.333 193.84 133.349 194.095 133.367 194.419C133.385 194.743 133.401 195.089 133.415 195.458C133.429 195.827 133.436 196.18 133.436 196.518V202H131.945V192.006H134.249L137.018 199.983H137.059L139.923 192.006H142.22V202H140.654V196.436C140.654 196.13 140.659 195.8 140.668 195.444C140.682 195.089 140.695 194.752 140.709 194.433C140.727 194.114 140.741 193.858 140.75 193.667H140.695L137.708 202H136.259ZM150.512 202H144.852V192.006H150.512V193.387H146.492V196.101H150.259V197.475H146.492V200.612H150.512V202ZM161.012 202H158.995L154.101 194.022H154.039C154.057 194.291 154.073 194.576 154.087 194.877C154.105 195.178 154.119 195.488 154.128 195.807C154.142 196.126 154.153 196.449 154.162 196.777V202H152.672V192.006H154.675L159.562 199.929H159.61C159.601 199.696 159.59 199.43 159.576 199.129C159.562 198.828 159.549 198.518 159.535 198.199C159.526 197.876 159.519 197.563 159.515 197.263V192.006H161.012V202ZM167.103 202H165.455V193.4H162.529V192.006H170.021V193.4H167.103V202ZM180.426 196.989C180.426 197.759 180.328 198.461 180.132 199.095C179.94 199.724 179.651 200.266 179.264 200.722C178.876 201.173 178.391 201.521 177.808 201.768C177.224 202.014 176.541 202.137 175.757 202.137C174.959 202.137 174.267 202.014 173.679 201.768C173.095 201.521 172.61 201.171 172.223 200.715C171.84 200.259 171.553 199.715 171.361 199.081C171.17 198.448 171.074 197.746 171.074 196.976C171.074 195.946 171.243 195.048 171.58 194.282C171.922 193.512 172.439 192.915 173.132 192.491C173.829 192.063 174.709 191.849 175.771 191.849C176.81 191.849 177.673 192.061 178.361 192.484C179.049 192.908 179.564 193.505 179.906 194.275C180.253 195.041 180.426 195.946 180.426 196.989ZM172.797 196.989C172.797 197.759 172.902 198.427 173.111 198.992C173.321 199.553 173.642 199.986 174.075 200.291C174.513 200.592 175.073 200.742 175.757 200.742C176.445 200.742 177.006 200.592 177.438 200.291C177.871 199.986 178.19 199.553 178.396 198.992C178.601 198.427 178.703 197.759 178.703 196.989C178.703 195.818 178.468 194.902 177.999 194.241C177.534 193.576 176.791 193.243 175.771 193.243C175.087 193.243 174.524 193.394 174.082 193.694C173.645 193.995 173.321 194.426 173.111 194.986C172.902 195.542 172.797 196.21 172.797 196.989Z"
						fill="#01395E"
					/>

					<path
						id="pilha_largura_barra"
						class="container__planejamento__imagem__transition"
						d="M232 172L324 80"
						stroke="#01395E"
						stroke-width="2"
						stroke-linecap="round"
					/>
					<path
						id="pilha_largura_texto"
						class="container__planejamento__imagem__transition"
						d="M270.405 161.879L263.338 154.813L264.498 153.652L270.579 159.733L273.581 156.732L274.567 157.718L270.405 161.879ZM280.169 152.115L277.515 150.844L274.813 153.546L276.084 156.2L274.862 157.423L270.395 147.697L271.681 146.411L281.402 150.883L280.169 152.115ZM276.22 150.148L273.614 148.886C273.505 148.828 273.35 148.748 273.15 148.645C272.947 148.538 272.743 148.43 272.536 148.321C272.327 148.208 272.151 148.113 272.01 148.036C272.109 148.2 272.217 148.388 272.333 148.601C272.449 148.807 272.556 149.004 272.652 149.191C272.752 149.375 272.83 149.516 272.885 149.616L274.141 152.226L276.22 150.148ZM277.254 140.896C277.863 140.287 278.44 139.859 278.985 139.61C279.533 139.359 280.055 139.288 280.551 139.398C281.05 139.504 281.534 139.791 282.001 140.258C282.349 140.606 282.581 140.967 282.697 141.341C282.813 141.715 282.847 142.087 282.798 142.457C282.75 142.828 282.655 143.181 282.513 143.516L287.647 144.638L286.337 145.947L281.798 144.821L280.662 145.957L283.495 148.79L282.334 149.95L275.268 142.883L277.254 140.896ZM278.144 141.94L277.394 142.69L279.705 145L280.507 144.198C281.045 143.659 281.335 143.17 281.377 142.728C281.422 142.283 281.25 141.866 280.86 141.476C280.451 141.067 280.03 140.907 279.599 140.998C279.17 141.085 278.685 141.399 278.144 141.94ZM287.671 136.937L290.31 134.298L293.858 137.846C293.61 138.339 293.322 138.818 292.993 139.282C292.664 139.746 292.253 140.224 291.76 140.717C291.042 141.436 290.291 141.903 289.508 142.119C288.725 142.329 287.934 142.292 287.134 142.008C286.332 141.721 285.547 141.194 284.78 140.427C284.042 139.689 283.546 138.906 283.292 138.078C283.034 137.247 283.031 136.409 283.282 135.565C283.53 134.717 284.044 133.903 284.824 133.124C285.207 132.74 285.617 132.408 286.052 132.128C286.487 131.841 286.92 131.614 287.352 131.446L287.903 132.809C287.552 132.935 287.189 133.107 286.815 133.327C286.442 133.546 286.095 133.815 285.776 134.134C285.27 134.64 284.943 135.186 284.795 135.772C284.65 136.356 284.679 136.945 284.882 137.542C285.082 138.135 285.452 138.702 285.994 139.243C286.519 139.768 287.059 140.15 287.613 140.389C288.167 140.627 288.723 140.69 289.281 140.577C289.838 140.458 290.384 140.131 290.919 139.596C291.187 139.328 291.399 139.087 291.557 138.871C291.715 138.655 291.855 138.45 291.978 138.257L290.155 136.435L288.662 137.928L287.671 136.937ZM294.322 123.828L298.895 128.401C299.388 128.894 299.725 129.44 299.905 130.04C300.089 130.636 300.086 131.258 299.895 131.905C299.702 132.55 299.288 133.19 298.653 133.824C297.748 134.73 296.821 135.183 295.874 135.183C294.926 135.176 294.058 134.778 293.268 133.989L288.715 129.435L289.875 128.275L294.327 132.727C294.917 133.317 295.49 133.613 296.048 133.617C296.605 133.62 297.16 133.346 297.711 132.795C298.091 132.415 298.334 132.039 298.44 131.669C298.547 131.292 298.527 130.918 298.382 130.547C298.237 130.17 297.981 129.798 297.614 129.431L293.167 124.984L294.322 123.828ZM298.117 120.034C298.726 119.425 299.302 118.996 299.847 118.748C300.395 118.497 300.917 118.426 301.413 118.535C301.913 118.642 302.396 118.928 302.863 119.396C303.211 119.744 303.443 120.105 303.559 120.478C303.675 120.852 303.709 121.224 303.661 121.595C303.613 121.966 303.518 122.319 303.376 122.654L308.509 123.775L307.199 125.085L302.66 123.959L301.524 125.095L304.357 127.927L303.197 129.087L296.13 122.02L298.117 120.034ZM299.006 121.078L298.257 121.827L300.567 124.138L301.37 123.335C301.908 122.797 302.198 122.307 302.24 121.866C302.285 121.421 302.113 121.004 301.723 120.614C301.313 120.205 300.893 120.045 300.461 120.135C300.032 120.222 299.547 120.536 299.006 121.078ZM313.899 118.385L311.245 117.114L308.543 119.816L309.814 122.47L308.591 123.693L304.125 113.967L305.411 112.682L315.131 117.153L313.899 118.385ZM309.95 116.418L307.344 115.157C307.235 115.099 307.08 115.018 306.88 114.915C306.677 114.809 306.473 114.701 306.266 114.591C306.057 114.478 305.881 114.383 305.739 114.306C305.839 114.47 305.947 114.659 306.063 114.871C306.179 115.078 306.286 115.274 306.382 115.461C306.482 115.645 306.56 115.787 306.614 115.886L307.871 118.497L309.95 116.418Z"
						fill="#01395E"
					/>
				</svg>
				<div
					class="container__planejamento__pilha__formulario__medidas__altura__comprimento"
					@mouseenter.capture="focarImagemEmAlturaComprimento('#95BB49')"
					@mouseleave="focarImagemEmAlturaComprimento('#01395E')"
				>
					<div>
						<div style="display: flex; align-items: flex-end">
							<Dropdown
								v-model="model.distanciaEntreAlturas"
								:label="$t('distanciaMedicoesDeAltura')"
								:options="optionsDistanciaEntreAlturas"
							/>
							<Tooltip
								style="margin-left: 0.5rem; margin-bottom: 0.5rem"
								titulo="Distância entre medições de altura"
								subtitulo="Ordem de serviço de pilha"
								conteudo="Irá determinar de quantos em quantos metros deverão ser realizadas as medições de altura ao longo da pilha."
							/>
						</div>
						<InputText
							v-show="model.distanciaEntreAlturas === 'personalizada'"
							v-model="model.distanciaEntreAlturasPersonalizado"
							placeholder="Distância entre medições (m)"
							:mask="['#.#', '##.#', '###.#']"
						/>
					</div>

					<Checkbox
						v-model="model.medirAlturasNaIdaENaVolta"
						style="margin-top: 1rem; color: red !important"
						:label="$t('medirIDaEVoltaDaPilha')"
						color="trv-primary"
					/>

					<div style="display: flex; align-items: center; margin-top: 1rem">
						<p class="container__planejamento__pilha__titulo__topico">
							{{ $t('tipoDeMedicaoDeComprimento') }}
						</p>
						<Tooltip
							style="margin-left: 0.5rem"
							titulo="Distância entre medições de altura"
							subtitulo="Ordem de serviço de pilha"
							conteudo="Determina como o comprimento da pilha será gerado na hora da coleta. <br/> <br/> A medição do comprimento total pelo coletor, permite que o sistema gere as posições de medição de acordo com o parâmetro definido na Ordem de Serviço.  <br/><br/> <b>Exemplo:</b> <br/>Comprimento = 100 m<br/>Distância entre medições = a cada 2,0 m<br/>Número de medições = 50  <br/><br/> Quando o comprimento não é medido inicialmente, ele é calculado à partir das distâncias entre alturas + comprimento final.  <br/><br/> <b>Exemplo:</b> <br/>Distância entre medições = a cada 3m<br/>Número de medições = 10 <br/>Comprimento final = 0,7 m<br/>Comprimento total = 30,7 m"
						/>
					</div>
					<RadioButtons
						v-model="model.calculaComprimentoTotal"
						group-name="tipos-medicao-altura"
						:options="optionsTipoMedicaoComprimento"
						color="trv-primary"
					/>
				</div>
				<div
					class="container__planejamento__pilha__formulario__medidas__largura"
					@mouseenter="focarImagemEmLargura('#95BB49')"
					@mouseleave="focarImagemEmLargura('#01395E')"
				>
					<div style="display: flex; align-items: center; margin-top: 1rem">
						<p class="container__planejamento__pilha__titulo__topico">
							{{ $t('quantidadeDeMedicoesDelargura') }}
						</p>
						<Tooltip
							style="margin-left: 0.5rem"
							titulo="Quantidade de medições de largura por pilha"
							subtitulo="Ordem de serviço de pilha"
							conteudo="Baseado na quantidade de medições de altura realizadas pelo coletor, este parâmetro irá definir quantas dessas posições serão aproveitadas para medição de largura. <br/> <br/> <b>Exemplo: </b> Ao preencher “50% das medidas de altura”, tendo 100 medições no total, o sistema irá gerar 50 cards para medição de largura."
						/>
					</div>
					<p
						v-show="mensagemDeValidacaoCampoQuantidadeDeMedidas"
						style="color: red; font-size: 0.75rem; margin: 0"
					>
						{{ mensagemDeValidacaoCampoQuantidadeDeMedidas }}
					</p>
					<RadioButtonsInputText
						v-model="model.quantidadeDeMedicoesDeLargura"
						group-name="tipos-quantidade-medicoes-de-largura"
						:options="optionsQuantidadeDeMedicaoesDeLarguraPorPilha"
						color="trv-primary"
					/>

					<div style="display: flex; align-items: center; margin-top: 1rem">
						<p class="container__planejamento__pilha__titulo__topico">
							{{ $t('controlarPosicaoMedicaoLargura') }}<span>{{ $t('opcional') }}</span>
						</p>
						<Tooltip
							style="margin-left: 0.5rem"
							titulo="Controlar posição da medição de largura por pilha"
							subtitulo="Ordem de serviço de pilha"
							:conteudo="`Utilizando a quantidade de medições determinada no campo anterior, escolher como será a distribuição da posição das amostras. <img style='margin: 1rem auto' src=${require('@/assets/pilha_largura_sistematico.svg')}> <img style='margin: 0 auto' src=${require('@/assets/pilha_largura_aleatoria.svg')}>`"
						/>
					</div>
					<Checkbox
						v-model="model.metodoDeMedicaoDeLarguras.sistematico"
						style="margin-top: 0.5rem"
						:label="$t('medicaoSistematica')"
						color="trv-primary"
						@click="determinarComoSistematico(model.metodoDeMedicaoDeLarguras)"
					/>
					<Checkbox
						v-model="model.metodoDeMedicaoDeLarguras.aleatorio"
						style="margin-top: 0.2rem"
						:label="$t('medicaoAleatoria')"
						color="trv-primary"
						@click="determinarComoAleatorio(model.metodoDeMedicaoDeLarguras)"
					/>
				</div>
			</div>
			<div
				v-show="tabFatorEstaAtivo"
				class="container__planejamento__pilha__formulario__fator"
			>
				<img
					ref="imagem_fator"
					class="container__planejamento__pilha__formulario__imagem__exemplo"
					:src="require('@/assets/fator_default.svg')"
				/>
				<Dropdown
					v-model="model.formaDeMedicaoDeFator"
					:label="$t('tipoDoFator')"
					:options="optionsTipoDoFator"
				/>

				<div style="display: flex; align-items: center; margin-top: 1rem">
					<p class="container__planejamento__pilha__titulo__topico">
						{{ $t('tamanhoDoGabarito') }}
					</p>
					<Tooltip
						style="margin-left: 0.5rem"
						titulo="Tamanho do gabarito"
						subtitulo="Ordem de serviço de pilha"
						conteudo="Selecione o tamanho do gabarito que será utilizado para medição de fator. Este valor poderá ser alterado em campo pelo coletor."
					/>
				</div>
				<InputText
					v-model="model.larguraDoGabarito"
					:mask="['#.#', '##.#', '###.#']"
					:label="$t('largura')"
				/>
				<p
					v-show="mensagemDeValidacaoCampoLarguraDoGabarito"
					style="color: red; font-size: 0.75rem; margin: 0"
				>
					{{ mensagemDeValidacaoCampoLarguraDoGabarito }}
				</p>
				<InputText
					v-model="model.alturaDoGabarito"
					:mask="['#.#', '##.#', '###.#']"
					:label="$t('altura')"
				/>
				<p
					v-show="mensagemDeValidacaoCampoAlturaDoGabarito"
					style="color: red; font-size: 0.75rem; margin: 0"
				>
					{{ mensagemDeValidacaoCampoAlturaDoGabarito }}
				</p>

				<div style="display: flex; align-items: center; margin-top: 1rem">
					<p class="container__planejamento__pilha__titulo__topico">
						{{ $t('quantidadeMedicaoDeFator') }}
					</p>
					<Tooltip
						style="margin-left: 0.5rem"
						titulo="Quantidade de medições de fator por pilha"
						subtitulo="Ordem de serviço de pilha"
						conteudo="Baseado na quantidade de medições de altura realizadas pelo coletor, este parâmetro irá definir quantas dessas posições serão aproveitadas para medição de fator.<br/><br/><b>Exemplo:</b> Ao preencher “50% das medidas de altura”, tendo 100 medições no total, o sistema irá gerar 50 cards para medição de fator."
					/>
				</div>
				<RadioButtonsInputText
					v-model="model.quantidadeDeMedicoesDeFator"
					group-name="tipos-quantidade-medicoes-de-fator"
					:options="optionsQuantidadeDeMedicaoesDeFatorPorPilha"
					color="trv-primary"
				/>
				<p
					v-show="mensagemDeValidacaoQuantidadeDeMedicoesDeFator"
					style="color: red; font-size: 0.75rem; margin: 0"
				>
					{{ mensagemDeValidacaoQuantidadeDeMedicoesDeFator }}
				</p>

				<div
					@mouseenter="setarImagemFator('fator_posicao_horizontal.svg')"
					@mouseleave="setarImagemFator('fator_default.svg')"
				>
					<div style="display: flex; align-items: center; margin-top: 1rem">
						<p class="container__planejamento__pilha__titulo__topico">
							{{ $t('controlarPosicaoMedicaoFator') }}<span>{{ $t('opcional') }}</span>
						</p>
						<Tooltip
							style="margin-left: 0.5rem"
							titulo="Controlar posição da medição de fator por pilha"
							subtitulo="Ordem de serviço de pilha"
							:conteudo="`Utilizando a quantidade de medições determinada no campo anterior, escolher como será a distribuição da posição das amostras. <img style='margin: 1rem auto' src=${require('@/assets/pilha_fator_horizontal_sistematico.svg')}> <img style='margin: 0 auto' src=${require('@/assets/pilha_fator_horizontal_aleatorio.svg')}>`"
						/>
					</div>
					<Checkbox
						v-model="model.metodoDeMedicaoHorizontalDoFator.sistematico"
						style="margin-top: 0.5rem"
						:label="$t('medicaoSistematica')"
						color="trv-primary"
						@click="determinarComoSistematico(model.metodoDeMedicaoHorizontalDoFator)"
					/>
					<Checkbox
						v-model="model.metodoDeMedicaoHorizontalDoFator.aleatorio"
						style="margin-top: 0.2rem"
						:label="$t('medicaoAleatoria')"
						color="trv-primary"
						@click="determinarComoAleatorio(model.metodoDeMedicaoHorizontalDoFator)"
					/>
				</div>

				<div
					@mouseenter="setarImagemFator('fator_posicao_vertical.svg')"
					@mouseleave="setarImagemFator('fator_default.svg')"
				>
					<div style="display: flex; align-items: center; margin-top: 1rem">
						<p class="container__planejamento__pilha__titulo__topico">
							{{ $t('controlarAlturaMedicaoFator') }}<span>{{ $t('opcional') }}</span>
						</p>
						<Tooltip
							style="margin-left: 0.5rem"
							titulo="Controlar altura das medições de fator por pilha"
							subtitulo="Ordem de serviço de pilha"
							:conteudo="`Para o controle das alturas, escolher como será a opção indicada. Sendo <b>Altura fixa</b> (medição será realizada sempre na mesma altura para todos os fatores) ou <b>Sorteio das posições</b> (onde define-se o limite operacional e o sorteio se concentra dentro deste limite) <img style='margin: 1rem auto' src=${require('@/assets/pilha_fator_vertical_sistematico.svg')}> <img style='margin: 0 auto' src=${require('@/assets/pilha_fator_vertical_aleatorio.svg')}>`"
						/>
					</div>
					<p
						v-show="mensagemDeValidacaoMedicaoVerticalFator"
						style="color: red; font-size: 0.75rem; margin: 0"
					>
						{{ mensagemDeValidacaoMedicaoVerticalFator }}
					</p>

					<div style="display: flex; align-items: flex-end">
						<Checkbox
							v-model="model.metodoDeMedicaoVerticalDoFator.sistematico"
							style="margin-top: 0.5rem"
							:label="$t('fixarPosicaoMedicaoAltura')"
							color="trv-primary"
							@click="
								determinarComoSistematico(model.metodoDeMedicaoVerticalDoFator)
								limparReferenciasDeAlturaDeFator()
							"
						/>
						<input
							v-model="
								model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico
							"
							class="container__planejamento__pilha__checkbox__input"
							type="number"
							@input="mudarMedicaoVerticalDeGabaritoParaSistematico"
						/>
						<p style="margin: 0; cursor: default; margin-left: 0.5rem">
							{{ $t('metros') }}
						</p>
					</div>
					<div style="display: flex; align-items: flex-end">
						<Checkbox
							v-model="model.metodoDeMedicaoVerticalDoFator.aleatorio"
							style="margin-top: 0.2rem"
							:label="$t('sortearPosicoesAltura')"
							color="trv-primary"
							@click="
								determinarComoAleatorio(model.metodoDeMedicaoVerticalDoFator)
								limparReferenciasDeAlturaDeFator()
							"
						/>
						<input
							v-model="
								model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio
							"
							class="container__planejamento__pilha__checkbox__input"
							type="number"
							@input="mudarMedicaoVerticalDeGabaritoParaAleatorio"
						/>
						<p style="margin: 0; cursor: default; margin-left: 0.5rem">
							{{ $t('metros') }}
						</p>
					</div>
				</div>
			</div>
			<div class="container__planejamento__pilha__formulario__botoes">
				<Button
					label="Cancelar"
					outlined
					@click="() => $emit('fecharModal')"
				/>
				<Button
					:label="textoBotao"
					:disabled="salvandoPlanejamentoDePilha"
					:loading="salvandoPlanejamentoDePilha"
					@click="clicouNoBotaoParaProsseguir"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

import { v4 as uuidv4 } from 'uuid'
import i18n from '../../../VueI18n'

import Button from '../../../components/Button/Button'
import Checkbox from '../../../components/Checkbox/Checkbox'
import Dropdown from '../../../components/Dropdown/Dropdown'
import InputText from '../../../components/InputText/InputText'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'
import RadioButtonsInputText from '../../../components/RadioButtonInputText/RadioButtonInputText'
import Tab from '../../../components/Tab/Tab'
import Tooltip from '../../../components/Tooltip/Tooltip'

import {
	cadastrarOrdemDeServicoDePilha,
	editarOrdemDeServicoDePilha,
} from '../../../services/requests/PlanejamentoDeOrdemDeServicoDePilhaRequests'

export default {
	components: {
		Button,
		Checkbox,
		Dropdown,
		InputText,
		RadioButtons,
		RadioButtonsInputText,
		Tab,
		Tooltip,
	},
	data() {
		return {
			tabMedidasEstaAtivo: true,
			tabFatorEstaAtivo: false,
			optionsDistanciaEntreAlturas: [
				{ label: i18n.t('aCada1m'), value: '1' },
				{ label: i18n.t('aCada5m'), value: '5' },
				{ label: i18n.t('aCada10m'), value: '10' },
				{ label: i18n.t('personalizada'), value: 'personalizada' },
			],
			optionsTipoMedicaoComprimento: [
				{ label: i18n.t('medirComprimentoTotalPilha'), value: false },
				{ label: i18n.t('calcularComprimentoPilha'), value: true },
			],
			optionsQuantidadeDeMedicaoesDeLarguraPorPilha: [
				{
					label: i18n.t('porcentagemMedidasAltura'),
					value: 'PERCENTUAL',
					left: true,
					right: false,
					placeholder: '%',
					type: 'number',
				},
				{
					label: i18n.t('numeroTotalMedicoes'),
					value: 'ABSOLUTO',
					left: false,
					right: true,
					type: 'number',
				},
			],
			optionsControlarPosicaoDaMedicaoDeLargura: [
				{ label: i18n.t('medicaoSistematica'), value: 'SISTEMATICO' },
				{ label: i18n.t('medicaoAleatoria'), value: 'ALEATORIO' },
			],
			optionsTipoDoFator: [
				{ label: i18n.t('gabarito'), value: 'GABARITO' },
				{ label: i18n.t('foto'), value: 'FOTO', hide: true },
			],
			optionsQuantidadeDeMedicaoesDeFatorPorPilha: [
				{
					label: i18n.t('porcentagemMedidasAltura'),
					value: 'PERCENTUAL',
					left: true,
					right: false,
					placeholder: '%',
					type: 'number',
				},
				{
					label: i18n.t('numeroTotalMedicoes'),
					value: 'ABSOLUTO',
					left: false,
					right: true,
					type: 'number',
				},
			],
			model: {
				distanciaEntreAlturas: '1',
				distanciaEntreAlturasPersonalizado: '',
				medirAlturasNaIdaENaVolta: true,
				calculaComprimentoTotal: true,
				quantidadeDeMedicoesDeLargura: {
					value: 'PERCENTUAL',
					input: 100,
				},
				metodoDeMedicaoDeLarguras: {
					sistematico: false,
					aleatorio: false,
					opcional: true,
				},
				formaDeMedicaoDeFator: 'GABARITO',
				quantidadeDeMedicoesDeFator: {
					value: 'PERCENTUAL',
					input: 100,
				},
				metodoDeMedicaoHorizontalDoFator: {
					sistematico: false,
					aleatorio: false,
					opcional: true,
				},
				metodoDeMedicaoVerticalDoFator: {
					sistematico: false,
					aleatorio: false,
					opcional: true,
					valorDeReferenciaDaAlturaDosFatoresSistematico: undefined,
					valorDeReferenciaDaAlturaDosFatoresAleatorio: undefined,
				},
				larguraDoGabarito: undefined,
				alturaDoGabarito: undefined,
			},
			mensagemDeValidacaoCampoQuantidadeDeMedidas: '',
			mensagemDeValidacaoQuantidadeDeMedicoesDeFator: '',
			mensagemDeValidacaoCampoLarguraDoGabarito: '',
			mensagemDeValidacaoCampoAlturaDoGabarito: '',
			mensagemDeValidacaoMedicaoVerticalFator: '',
			salvandoPlanejamentoDePilha: false,
		}
	},
	computed: {
		textoBotao() {
			if (this.tabMedidasEstaAtivo) return 'Avançar'
			return 'Finalizar'
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		exibirFormularioDeMedidas() {
			this.tabMedidasEstaAtivo = true
			this.tabFatorEstaAtivo = false
		},
		exibirFormularioDeFator() {
			this.tabMedidasEstaAtivo = false
			this.tabFatorEstaAtivo = true
		},
		focarImagemEmAlturaComprimento(cor) {
			let elementos = document.querySelectorAll('#pilha_altura_comprimento_barra')
			elementos.forEach((element) => (element.style.stroke = cor))

			elementos = document.querySelectorAll('#pilha_altura_comprimento_texto')
			elementos.forEach((element) => (element.style.fill = cor))
		},
		focarImagemEmLargura(cor) {
			let elementos = document.querySelectorAll('#pilha_largura_barra')
			elementos.forEach((element) => (element.style.stroke = cor))

			elementos = document.querySelectorAll('#pilha_largura_texto')
			elementos.forEach((element) => (element.style.fill = cor))
		},
		setarImagemFator(nomeDaImagem) {
			this.$refs.imagem_fator.src = require(`@/assets/${nomeDaImagem}`)
		},
		determinarComoSistematico(opcao) {
			if (opcao.sistematico) {
				opcao.aleatorio = false
				opcao.opcional = false
			} else if (!opcao.aleatorio) {
				opcao.opcional = true
			}
		},
		determinarComoAleatorio(opcao) {
			if (opcao.aleatorio) {
				opcao.sistematico = false
				opcao.opcional = false
			} else if (!opcao.sistematico) {
				opcao.opcional = true
			}
		},
		limparReferenciasDeAlturaDeFator() {
			this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico =
				undefined
			this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio =
				undefined
		},
		mudarMedicaoVerticalDeGabaritoParaAleatorio() {
			if (this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio) {
				this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico =
					undefined
				this.model.metodoDeMedicaoVerticalDoFator.aleatorio = true
				this.model.metodoDeMedicaoVerticalDoFator.sistematico = false
				this.model.metodoDeMedicaoVerticalDoFator.opcional = false
			}
		},
		mudarMedicaoVerticalDeGabaritoParaSistematico() {
			if (
				this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico
			) {
				this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio =
					undefined
				this.model.metodoDeMedicaoVerticalDoFator.sistematico = true
				this.model.metodoDeMedicaoVerticalDoFator.aleatorio = false
				this.model.metodoDeMedicaoVerticalDoFator.opcional = false
			}
		},
		clicouNoBotaoParaProsseguir() {
			const quantidadeDeLargurasDePilhaEstaValido = this.validarQuantidadeDeLargurasPorPilha()

			if (!quantidadeDeLargurasDePilhaEstaValido) this.ativarTabDeMedidas()
			else if (this.tabMedidasEstaAtivo) {
				this.ativarTabDeFator()
			} else {
				const dimensoesDoGabaritEstaValido = this.validarDimensoesDoGabarito()
				const quantidadeDeMedicoesDeFatorPorPilhaEstaValido =
					this.validarQuantidadeDeMedicoesDeFatorPorPilha()
				const alturaDaMedicaoDoFatorEstaValido = this.validarAlturaDaMedicaoDoFator()

				if (
					dimensoesDoGabaritEstaValido &&
					quantidadeDeMedicoesDeFatorPorPilhaEstaValido &&
					alturaDaMedicaoDoFatorEstaValido
				) {
					this.salvandoPlanejamentoDePilha = true

					if (!this.dadosDePilhaParaEdicao) {
						const body = this.montarObjetoParaCadastrarOrdemDeServico()
						cadastrarOrdemDeServicoDePilha(body)
							.then((response) => {
								const { data: ordemDeServico } = response
								this.$emit('fecharModal')
								this.$emit('salvouPlanejamentoDePilha', ordemDeServico)
								this.salvandoPlanejamentoDePilha = false
								this.mutationShowMessage({
									messageTitle: 'Sucesso',
									messageIcon: 'far fa-check-circle',
									messageType: 'success',
								})
							})
							.catch(() => {
								this.mutationShowMessage({
									messageTitle: 'Erro',
									messageText:
										'O servidor encontrou um erro ao salvar o planejamento, tente novamente!',
									messageIcon: 'far fa-check-circle',
									messageType: 'error',
								})
								this.salvandoPlanejamentoDePilha = false
							})
					} else {
						const body = this.montarObjetoParaEditarOrdemDeServico()
						editarOrdemDeServicoDePilha(this.dadosDePilhaParaEdicao.id, body)
							.then((response) => {
								const { data: ordemDeServico } = response
								this.$emit('fecharModal')
								this.$emit('editouPlanejamentoDePilha', ordemDeServico)
								this.salvandoPlanejamentoDePilha = false
								this.mutationShowMessage({
									messageTitle: 'Sucesso',
									messageIcon: 'far fa-check-circle',
									messageType: 'success',
								})
							})
							.catch(() => {
								this.mutationShowMessage({
									messageTitle: 'Erro',
									messageText:
										'O servidor encontrou um erro ao salvar o planejamento, tente novamente!',
									messageIcon: 'far fa-check-circle',
									messageType: 'error',
								})
								this.salvandoPlanejamentoDePilha = false
							})
					}
				}
			}
		},
		ativarTabDeMedidas() {
			this.tabMedidasEstaAtivo = true
			this.tabFatorEstaAtivo = false
		},
		ativarTabDeFator() {
			this.tabMedidasEstaAtivo = false
			this.tabFatorEstaAtivo = true
		},
		montarObjetoParaCadastrarOrdemDeServico() {
			const { sistematico: sistematicoLargura, aleatorio: aleatorioLargura } =
				this.model.metodoDeMedicaoDeLarguras
			const metodoMedicaoLargura = sistematicoLargura
				? 'SISTEMATICO'
				: aleatorioLargura
					? 'ALEATORIO'
					: 'OPCIONAL'

			const { sistematico: sistematicoHorizontalFator, aleatorio: aleatorioHorizontalFator } =
				this.model.metodoDeMedicaoHorizontalDoFator
			const metodoMedicaoHorizontalFator = sistematicoHorizontalFator
				? 'SISTEMATICO'
				: aleatorioHorizontalFator
					? 'ALEATORIO'
					: 'OPCIONAL'

			const { sistematico: sistematicoVerticalFator, aleatorio: aleatorioVerticalFator } =
				this.model.metodoDeMedicaoVerticalDoFator
			const metodoMedicaoVerticalFator = sistematicoVerticalFator
				? 'SISTEMATICO'
				: aleatorioVerticalFator
					? 'ALEATORIO'
					: 'OPCIONAL'

			const valorReferenciaDeAlturaVerticalDoFator = sistematicoVerticalFator
				? this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico
				: aleatorioVerticalFator
					? this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio
					: null

			return {
				ordemDeServicoId: uuidv4(),
				descricaoOrdemDeServico: this.descricaoOrdemDeServico,
				estratoFlorestalId: this.estratoFlorestalId,
				dataInicial: this.dataInicial,
				prazoDeExecucao: this.prazoDeExecucao,
				executoresId: this.executores,
				geofence: this.geofence,
				distanciaEntreAlturas:
					this.model.distanciaEntreAlturas !== 'personalizada'
						? this.model.distanciaEntreAlturas
						: this.model.distanciaEntreAlturasPersonalizado,
				calculaComprimentoTotal: this.model.calculaComprimentoTotal,
				medirAlturasNaIdaENaVolta: this.model.medirAlturasNaIdaENaVolta,
				tipoDeQuantidadeDeMedicoesDeLargura: this.model.quantidadeDeMedicoesDeLargura.value,
				quantidadeDeMedicoesDeLargura: this.model.quantidadeDeMedicoesDeLargura.input,
				metodoDeMedicaoDeLarguras: metodoMedicaoLargura,
				formaDeMedicaoDeFator: this.model.formaDeMedicaoDeFator,
				larguraDoGabarito: this.model.larguraDoGabarito,
				alturaDoGabarito: this.model.alturaDoGabarito,
				tipoDeQuantidadeDeMedicoesDeFator: this.model.quantidadeDeMedicoesDeFator.value,
				quantidadeDeMedicoesDeFator: this.model.quantidadeDeMedicoesDeFator.input,
				metodoDeMedicaoHorizontalDoFator: metodoMedicaoHorizontalFator,
				metodoDeMedicaoVerticalDoFator: metodoMedicaoVerticalFator,
				valorDeReferenciaDaAlturaDosFatores: valorReferenciaDeAlturaVerticalDoFator,
			}
		},
		montarObjetoParaEditarOrdemDeServico() {
			const { sistematico: sistematicoLargura, aleatorio: aleatorioLargura } =
				this.model.metodoDeMedicaoDeLarguras
			const metodoMedicaoLargura = sistematicoLargura
				? 'SISTEMATICO'
				: aleatorioLargura
					? 'ALEATORIO'
					: 'OPCIONAL'

			const { sistematico: sistematicoHorizontalFator, aleatorio: aleatorioHorizontalFator } =
				this.model.metodoDeMedicaoHorizontalDoFator
			const metodoMedicaoHorizontalFator = sistematicoHorizontalFator
				? 'SISTEMATICO'
				: aleatorioHorizontalFator
					? 'ALEATORIO'
					: 'OPCIONAL'

			const { sistematico: sistematicoVerticalFator, aleatorio: aleatorioVerticalFator } =
				this.model.metodoDeMedicaoVerticalDoFator
			const metodoMedicaoVerticalFator = sistematicoVerticalFator
				? 'SISTEMATICO'
				: aleatorioVerticalFator
					? 'ALEATORIO'
					: 'OPCIONAL'

			const valorReferenciaDeAlturaVerticalDoFator = sistematicoVerticalFator
				? this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico
				: aleatorioVerticalFator
					? this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio
					: null

			return {
				ordemDeServicoId: this.ordemDeServicoId,
				descricaoOrdemDeServico: this.descricaoOrdemDeServico,
				estratoFlorestalId: this.estratoFlorestalId,
				dataInicial: this.dataInicial,
				prazoDeExecucao: this.prazoDeExecucao,
				executoresId: this.executores,
				geofence: this.geofence,
				distanciaEntreAlturas:
					this.model.distanciaEntreAlturas !== 'personalizada'
						? this.model.distanciaEntreAlturas
						: this.model.distanciaEntreAlturasPersonalizado,
				calculaComprimentoTotal: this.model.calculaComprimentoTotal,
				medirAlturasNaIdaENaVolta: this.model.medirAlturasNaIdaENaVolta,
				tipoDeQuantidadeDeMedicoesDeLargura: this.model.quantidadeDeMedicoesDeLargura.value,
				quantidadeDeMedicoesDeLargura: this.model.quantidadeDeMedicoesDeLargura.input,
				metodoDeMedicaoDeLarguras: metodoMedicaoLargura,
				formaDeMedicaoDeFator: this.model.formaDeMedicaoDeFator,
				larguraDoGabarito: this.model.larguraDoGabarito,
				alturaDoGabarito: this.model.alturaDoGabarito,
				tipoDeQuantidadeDeMedicoesDeFator: this.model.quantidadeDeMedicoesDeFator.value,
				quantidadeDeMedicoesDeFator: this.model.quantidadeDeMedicoesDeFator.input,
				metodoDeMedicaoHorizontalDoFator: metodoMedicaoHorizontalFator,
				metodoDeMedicaoVerticalDoFator: metodoMedicaoVerticalFator,
				valorDeReferenciaDaAlturaDosFatores: valorReferenciaDeAlturaVerticalDoFator,
			}
		},
		validarQuantidadeDeLargurasPorPilha() {
			if (!this.model.quantidadeDeMedicoesDeLargura.input)
				this.mensagemDeValidacaoCampoQuantidadeDeMedidas = 'Este campo é obrigatório'
			return this.mensagemDeValidacaoCampoQuantidadeDeMedidas === ''
		},
		validarDimensoesDoGabarito() {
			if (!this.model.alturaDoGabarito)
				this.mensagemDeValidacaoCampoAlturaDoGabarito = 'Este campo é obrigatório'
			if (!this.model.larguraDoGabarito)
				this.mensagemDeValidacaoCampoLarguraDoGabarito = 'Este campo é obrigatório'

			return (
				this.mensagemDeValidacaoCampoAlturaDoGabarito === '' &&
				this.mensagemDeValidacaoCampoLarguraDoGabarito === ''
			)
		},
		validarQuantidadeDeMedicoesDeFatorPorPilha() {
			if (!this.model.quantidadeDeMedicoesDeFator.input)
				this.mensagemDeValidacaoQuantidadeDeMedicoesDeFator = 'Este campo é obrigatório'

			return this.mensagemDeValidacaoQuantidadeDeMedicoesDeFator === ''
		},
		validarAlturaDaMedicaoDoFator() {
			const medicaoOpcional = this.model.metodoDeMedicaoVerticalDoFator.opcional
			if (medicaoOpcional) return true

			const medicaoSistematica = this.model.metodoDeMedicaoVerticalDoFator.sistematico
			if (medicaoSistematica) {
				return this.medicaoVerticalDeFatorSistematicaEstaValida()
			} else {
				return this.medicaoVerticalDeFatorAleatoriaEstaValida()
			}
		},
		medicaoVerticalDeFatorSistematicaEstaValida() {
			if (!this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico)
				this.mensagemDeValidacaoMedicaoVerticalFator =
					'Este campo quando marcado passa a ser obrigatório o preenchimento da altura'

			return this.mensagemDeValidacaoMedicaoVerticalFator === ''
		},
		medicaoVerticalDeFatorAleatoriaEstaValida() {
			if (!this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio)
				this.mensagemDeValidacaoMedicaoVerticalFator =
					'Este campo quando marcado passa a ser obrigatório o preenchimento da altura'

			return this.mensagemDeValidacaoMedicaoVerticalFator === ''
		},
	},
	props: {
		ordemDeServicoId: {
			type: String,
		},
		estratoFlorestalId: {
			required: true,
			type: String,
		},
		estratoFlorestal: {
			required: true,
			type: String,
		},
		descricaoOrdemDeServico: {
			required: true,
			type: String,
		},
		dataInicial: {
			required: true,
			type: Date,
		},
		prazoDeExecucao: {
			required: true,
			type: Date,
		},
		executores: {
			required: true,
			type: Array,
		},
		geofence: {
			type: String,
		},
		dadosDePilhaParaEdicao: {
			type: Object,
		},
	},
	watch: {
		'model.quantidadeDeMedicoesDeLargura.input': function (novaQuantidadeDeMedicoes) {
			if (novaQuantidadeDeMedicoes) this.mensagemDeValidacaoCampoQuantidadeDeMedidas = ''
		},
		'model.quantidadeDeMedicoesDeFator.input': function (novaQuantidadeDeMedicoesDeFator) {
			if (novaQuantidadeDeMedicoesDeFator) this.mensagemDeValidacaoQuantidadeDeMedicoesDeFator = ''
		},
		'model.alturaDoGabarito': function (novaAlturaDoGabarito) {
			if (novaAlturaDoGabarito) this.mensagemDeValidacaoCampoAlturaDoGabarito = ''
		},
		'model.larguraDoGabarito': function (novaLarguraDoGabarito) {
			if (novaLarguraDoGabarito) this.mensagemDeValidacaoCampoLarguraDoGabarito = ''
		},
		'model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico':
			function (novaReferenciaDeAlturaSistematico) {
				if (novaReferenciaDeAlturaSistematico) this.mensagemDeValidacaoMedicaoVerticalFator = ''
			},
		'model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio': function (
			novaReferenciaDeAlturaAleatorio,
		) {
			if (novaReferenciaDeAlturaAleatorio) this.mensagemDeValidacaoMedicaoVerticalFator = ''
		},
	},
	created() {
		if (this.dadosDePilhaParaEdicao) {
			const distanciaEntreAlturasPersonalizada = !['1', '5', '10'].includes(
				this.dadosDePilhaParaEdicao.distanciaEntreAlturas.toString(),
			)

			;((this.model.distanciaEntreAlturas = distanciaEntreAlturasPersonalizada
				? 'personalizada'
				: this.dadosDePilhaParaEdicao.distanciaEntreAlturas.toString()),
				(this.model.distanciaEntreAlturasPersonalizado = distanciaEntreAlturasPersonalizada
					? this.dadosDePilhaParaEdicao.distanciaEntreAlturas.toString()
					: ''),
				(this.model.medirAlturasNaIdaENaVolta =
					this.dadosDePilhaParaEdicao.medirAlturasNaIdaENaVolta))
			this.model.calculaComprimentoTotal = this.dadosDePilhaParaEdicao.calculaComprimentoTotal
			this.model.quantidadeDeMedicoesDeLargura.value =
				this.dadosDePilhaParaEdicao.tipoDeQuantidadeDeMedicoesDeLargura
			this.model.quantidadeDeMedicoesDeLargura.input =
				this.dadosDePilhaParaEdicao.quantidadeDeMedicoesDeLargura
			this.model.metodoDeMedicaoDeLarguras.sistematico =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoDeLarguras === 'SISTEMATICO'
			this.model.metodoDeMedicaoDeLarguras.aleatorio =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoDeLarguras === 'ALEATORIO'
			this.model.metodoDeMedicaoDeLarguras.opcional =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoDeLarguras === 'OPCIONAL'
			this.model.formaDeMedicaoDeFator = this.dadosDePilhaParaEdicao.formaDeMedicaoDeFator
			this.model.quantidadeDeMedicoesDeFator.value =
				this.dadosDePilhaParaEdicao.tipoDeQuantidadeDeMedicoesDeFator
			this.model.quantidadeDeMedicoesDeFator.input =
				this.dadosDePilhaParaEdicao.quantidadeDeMedicoesDeFator
			this.model.metodoDeMedicaoHorizontalDoFator.sistematico =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoHorizontalDoFator === 'SISTEMATICO'
			this.model.metodoDeMedicaoHorizontalDoFator.aleatorio =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoHorizontalDoFator === 'ALEATORIO'
			this.model.metodoDeMedicaoHorizontalDoFator.opcional =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoHorizontalDoFator === 'OPCIONAL'
			this.model.metodoDeMedicaoVerticalDoFator.sistematico =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoVerticalDoFator === 'SISTEMATICO'
			this.model.metodoDeMedicaoVerticalDoFator.aleatorio =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoVerticalDoFator === 'ALEATORIO'
			this.model.metodoDeMedicaoVerticalDoFator.opcional =
				this.dadosDePilhaParaEdicao.metodoDeMedicaoVerticalDoFator === 'OPCIONAL'
			this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresSistematico =
				this.model.metodoDeMedicaoVerticalDoFator.sistematico
					? this.dadosDePilhaParaEdicao.valorDeReferenciaDaAlturaDosFatores
					: undefined
			this.model.metodoDeMedicaoVerticalDoFator.valorDeReferenciaDaAlturaDosFatoresAleatorio = this
				.model.metodoDeMedicaoVerticalDoFator.aleatorio
				? this.dadosDePilhaParaEdicao.valorDeReferenciaDaAlturaDosFatores
				: undefined
			this.model.larguraDoGabarito = this.dadosDePilhaParaEdicao.larguraDoGabarito
			this.model.alturaDoGabarito = this.dadosDePilhaParaEdicao.alturaDoGabarito
		}
	},
}
</script>

<style scoped>
.container__planejamento__pilha {
	display: flex;
	flex-direction: column;
}

.container__planejamento__pilha__estrato {
	margin: 1rem 0;
	border-radius: 5px;
	display: flex;
	align-items: center;
	background-color: var(--color-background);
	padding: 1rem;
	flex-direction: row;
	font-size: 0.8rem;
}

.container__planejamento__pilha__estrato > i {
	font-size: 1.5rem;
}

.container__planejamento__pilha__estrato > p {
	margin: 0;
	margin-left: 0.5rem;
	cursor: default;
}

.container__planejamento__pilha__tabs {
	display: flex;
	width: 100%;
}

.container__planejamento__pilha__formulario {
	height: 100%;
}

.container__planejamento__pilha__formulario__imagem__exemplo {
	max-width: 400px;
	height: 200px;
	margin: 1rem auto;
}

.container__planejamento__pilha__titulo__topico {
	margin: 0;
	font-weight: 700;
	color: rgb(var(--color-primary));
	cursor: default;
}

.container__planejamento__pilha__titulo__topico > span {
	font-weight: 500;
	color: var(--color-gray-c4);
	margin-left: 0.5rem;
}

.container__planejamento__pilha__formulario__botoes {
	margin-top: 1rem;
	display: flex;
}

.container__planejamento__imagem__transition {
	transition: all ease-in-out 0.2s;
}

.container__planejamento__pilha__checkbox__input,
.container__planejamento__pilha__checkbox__input:focus-visible {
	height: 15px;
	width: 50px;
	border-radius: 5px;
	padding: 0.2rem;
	border: 1px solid var(--color-gray);
	text-align: center;
	-moz-appearance: textfield;
	margin-left: 0.5rem;
	outline: none;
}

.container__planejamento__pilha__checkbox__input::-webkit-inner-spin-button,
.container__planejamento__pilha__checkbox__input::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.container__planejamento__pilha__checkbox__input::placeholder {
	text-align: center;
}
</style>
